import React, { useEffect, useState } from "react"
import store from "../utils/store"
// import Utterances from "utterances-react"
import { MDXProvider } from "@mdx-js/react"
import { graphql, PageProps, Link } from "gatsby"
import Layout from "../components/layout"
// import Newutt from "./../components/newutt"
import Img from "gatsby-image"
import { Calendar } from "react-feather"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { Myutterances } from "../components/myutterances"

import { Row, Col } from "../components/shortcodes/index"

// import Comments from "../components/comments"
import { BlogQuery } from "./__generated__/BlogQuery"

export default function blog({ location, data }: PageProps<BlogQuery, {}>) {
    let previous,
        next = null
    data.allMdx.edges.forEach(a_blog_info => {
        if (a_blog_info.node.fields.slug === data.mdx.fields.slug) {
            previous = a_blog_info.previous
            next = a_blog_info.next
        }
    })

    return (
        <Layout
            seo={{
                title: data.mdx.frontmatter.title,
                description: data.mdx.frontmatter.description,
                image: data.mdx.frontmatter.banner.publicURL,
            }}
            location={location}
        >
            <div className="md:px-4 mt-12 py-6 md:w-11/12 mx-auto">
                <div className="mx-auto relative">
                    <Img
                        fluid={
                            data.mdx.frontmatter.banner.childImageSharp.fluid
                        }
                    />
                    <div className="relative w-full lg:w-3/4 md:w-11/12 sm:w-full p-6 box-border lg:box-content mx-auto bg-bg text-color-default blog-wall-content shadow-xl md:-mt-16 ">
                        <div className="p-3">
                            <h1 className="text-5xl font-bold text-primary">
                                {data.mdx.frontmatter.title}
                            </h1>
                            <p className="mt-1 flex">
                                <Calendar />{" "}
                                <span className="ml-2">
                                    {data.mdx.frontmatter.date}
                                </span>
                            </p>
                            <p className="mt-3">
                                {data.mdx.frontmatter.description}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="lg:w-3/4 md:w-11/12 sm:w-full p-3 mx-auto mt-12 post-content">
                    <MDXProvider components={{ Row, Col }}>
                        <MDXRenderer>{data.mdx.body}</MDXRenderer>
                    </MDXProvider>
                    <hr />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            justifyContent: "space-between",
                        }}
                    >
                        <div>
                            {previous && (
                                <Link
                                    to={previous.fields.slug}
                                    title={previous.frontmatter.title}
                                    className="text-color-2 focus:text-primary"
                                >
                                    <span>&#8592;</span>&emsp;
                                    {previous.frontmatter.title}
                                </Link>
                            )}
                        </div>

                        <div>
                            {next && (
                                <Link
                                    to={next.fields.slug}
                                    title={next.frontmatter.title}
                                    className="text-color-2 focus:text-primary"
                                >
                                    {next.frontmatter.title}&emsp;
                                    <span>&#8594;</span>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                <div className="comments mt-8">
                    <Myutterances
                        repo={
                            "personal-website-services/elemental-demo-comment"
                        }
                    />
                </div>
            </div>
        </Layout>
    )
}

export const query = graphql`
    query BlogQuery($slug: String!) {
        mdx(fields: { slug: { eq: $slug } }) {
            body
            fields {
                slug
            }
            frontmatter {
                title
                date(formatString: "DD MMMM YYYY")
                description
                banner {
                    publicURL
                    childImageSharp {
                        fluid(maxWidth: 1920) {
                            srcSet
                            ...GatsbyImageSharpFluid
                        }
                        id
                    }
                }
            }
        }
        allMdx(
            sort: { fields: frontmatter___date, order: DESC }
            filter: { fields: { sourceName: { eq: "blog" } } }
        ) {
            edges {
                previous {
                    fields {
                        slug
                    }
                    frontmatter {
                        title
                    }
                }
                node {
                    fields {
                        slug
                    }
                    frontmatter {
                        title
                    }
                }
                next {
                    fields {
                        slug
                    }
                    frontmatter {
                        title
                    }
                }
            }
        }
    }
`
